
import {useState, useEffect} from 'react';
import { changeDisable, getPermission, showMessageError } from '../../../classes/functions';
import './generics.css';
import Title from '../../../components/Title';
import Header from '../../../components/Header';
import Division from '../../../components/Division';
import Lateral from '../../../components/Lateral';
import { toast } from 'react-toastify';
import api from '../../../config.js';
import { Link, useHistory, useParams } from 'react-router-dom';
import { FaTrash, FaArrowAltCircleLeft, FaCog } from 'react-icons/fa';
import ReactTooltip from "react-tooltip";

export default function Generics(){
  const { option, id } = useParams();
  const history = useHistory();
  const [view, setView] = useState(false);
  const [carrying, setCarrying] = useState(true);

  const [chave, setChave] = useState('');
  const [tabela, setTabela] = useState('');
  const [descricao, setDescricao] = useState('');
  const [observacao, setObservacao] = useState('');
  const [fluxo, setFluxo] = useState('');
  const [ativo, setAtivo] = useState('');
  const [rows, setRows] = useState([]);

  const [formChave, setFormChave] = useState('');
  const [formTabela, setFormTabela] = useState('');
  const [formDescricao, setFormDescricao] = useState('');
  const [formObservacao, setFormObservacao] = useState('');
  const [formFluxo, setFormFluxo] = useState('');
  const [formAtivo, setFormAtivo] = useState('');

  const [rowsRemovidos, setRowsRemovidos] = useState([]);

  useEffect(()=> {
    async function loadGenerics(){
      if (id) {
        getOne(id, option);
      } else {
        setCarrying(false);
      }
    }

    loadGenerics();

  },[]);

  function save(e){
    setCarrying(true);
    e.preventDefault();
    
    const data = {
      row: {
        chave: chave,
        tabela: tabela,
        descricao: descricao,
        observacao: observacao,
        fluxo: fluxo,
        ativo: ativo,
        rows: rows,
        rowsRemovidos: rowsRemovidos
      }
    }

    if (id) { 
      data.row.id = id;
      api.put("/api/generics/put", data)
      .then((response) => {
          toast.success('Registro atualizado com sucesso.');
          history.push('/generics');
        }
      ).catch((error) => {
        showMessageError(error.response.data);
        setCarrying(false);
      });
    } else {
      api.post("/api/generics/post", data)
      .then((response) => {
          toast.success('Registro inserido com sucesso.');
          history.push('/generics');
      setCarrying(false);
        }
      ).catch((error) => {
        showMessageError(error.response.data);
        setCarrying(false);
      });
    }
  }

  function getOne(id, option){
    api.get("/api/generics/getList?id=" + id)
    .then((response) => {
        setChave(response.data.row.chave);
        setTabela(response.data.row.tabela);
        setDescricao(response.data.row.descricao);
        setObservacao(response.data.row.observacao);
        setFluxo(response.data.row.fluxo);
        setAtivo(response.data.row.ativo);
        setRows(response.data.rows);
        setCarrying(false);
      }
    ).catch((error) => {
      showMessageError(error.response.data);
      setCarrying(false);
    });

    setView(changeDisable(option));
  }

  function cancel(){
    history.push('/generics');
  }

  function validityChave() {

  }
  
  async function setGenericItem(index, value, field) {
    let aux = [];
    
    rows.forEach((element, inx) => {
      if (inx === index) {
        element[field] = value;
      }

      aux.push(element);
    });
    
    setRows(() => aux);
  }

  function addItem() {
    if (!view) {
      let newItem = { 
        chave: formChave,
        tabela: formTabela,
        descricao: formDescricao,
        observacao: formObservacao,
        fluxo: formFluxo,
        ativo: formAtivo,
      }

      rows.push(newItem);

      setFormChave('');
      setFormTabela('');
      setFormDescricao('');
      setFormObservacao('');
      setFormFluxo('');
      setFormAtivo('');
    }
  }

  function rmItem(index) {
    if (!view) {
      let newListRows = [];
      let newRowsRemovidos = [];

      rows.forEach((element, idx) => {
        if (index !== idx) {
          newListRows.push(element);
        } else {
          newRowsRemovidos.push(element);
        }
      });
      
      setRows(newListRows);
      setRowsRemovidos(newRowsRemovidos);
    }
  }

  return(
    <div>
      <Header/>
      <Division/>
      <Lateral/>
      <ReactTooltip />
      
      {carrying && <div className="content">
        <div className="divCarrying">
          <span>Carregando..</span>
          <FaCog icon="spinner" className="spinner" />
        </div>
      </div>}
      {!carrying && <div className="content">
        <Title name="Cadastro de Tabelas Genéricas">
          <Link to="/generics">
            <FaArrowAltCircleLeft data-tip="Voltar" color="#001675" className="arrowIcon" size={40} />
          </Link>
        </Title>
        <div className="container">
          <form className="form-profile customers">
            <div className="containerGroupData">
              <h2>Dados Cadastrais</h2>
              <hr></hr>
              <div className="divGroup">
                <div className="formDiv">
                  <label>Chave</label><br/>
                  <input type="text" placeholder="Chave" value={chave} onChange={ (e) => setChave(e.target.value) } onBlur={validityChave} maxLength="6" disabled={view}/>
                </div>
                <div className="formDiv">
                  <label>Descrição</label><br/>
                  <input type="text" placeholder="Descrição" value={descricao} onChange={ (e) => setDescricao(e.target.value) } maxLength="100" disabled={view}/>
                </div>
                <div className="formDiv">
                  <label>Observação</label><br/>
                  <input type="text" placeholder="Observação" value={observacao} onChange={ (e) => setObservacao(e.target.value) } maxLength="100" disabled={view}/>
                </div>
                <div className="formDiv">
                  <label>Ativo</label><br/>
                  <select value={ativo} onChange={ (e) => setAtivo(e.target.value) } disabled={view}>
                    <option>Selecione</option>
                    <option value="S">Sim</option>
                    <option value="N">Não</option>
                  </select>
                </div>
              </div>
            </div>
            <br />
            <div className="containerGroupData">
              <h2>Registros</h2>
              <hr></hr>
              <div className="divGroup">
                <div className="formDiv">
                  <table>
                    <thead>
                      <tr>
                        <th scope="col">Chave</th>
                        <th scope="col">Descrição</th>
                        <th scope="col">Observação</th>
                        <th scope="col">Fluxo</th>
                        <th scope="col">Ativo</th>
                        <th scope="col"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <input type="text" placeholder="Chave" value={formChave} onChange={ (e) => setFormChave(e.target.value) } maxLength="6" disabled={view}/>
                        </td>
                        <td>
                          <input type="text" placeholder="Descrição" value={formDescricao} onChange={ (e) => setFormDescricao(e.target.value) } maxLength="100" disabled={view}/>
                        </td>
                        <td>
                          <input type="text" placeholder="Observação" value={formObservacao} onChange={ (e) => setFormObservacao(e.target.value) } maxLength="100" disabled={view}/>
                        </td>
                        <td>
                          <input type="text" placeholder="Fluxo" value={formFluxo} onChange={ (e) => setFormFluxo(e.target.value) } maxLength="50" disabled={view}/>
                        </td>
                        <td>
                          <select value={formAtivo} onChange={ (e) => setFormAtivo(e.target.value) } disabled={view}>
                            <option>Selecione</option>
                            <option value="S">Sim</option>
                            <option value="N">Não</option>
                          </select>
                        </td>
                        <td> 
                          <Link className="button-action" onClick={addItem} disabled={view}>
                            Adicionar
                          </Link>
                        </td> 
                      </tr>
                      {rows.map((item, index)=>{
                        return(
                          <tr key={index}>
                            <td>
                              {/* {item.chave} */}
                              <input type="text" placeholder="Chave" value={item.chave} onChange={ (e) => setGenericItem(index, e.target.value, 'chave') } maxLength="6" disabled={view}/>
                            </td>
                            <td>
                              {/* {item.descricao} */}
                              <input type="text" placeholder="Descrição" value={item.descricao} onChange={ (e) => setGenericItem(index, e.target.value, 'descricao') } maxLength="100" disabled={view}/>
                            </td>
                            <td>
                              {/* {item.observacao} */}
                              <input type="text" placeholder="Observação" value={item.observacao} onChange={ (e) => setGenericItem(index, e.target.value, 'observacao') } maxLength="100" disabled={view}/>
                            </td>
                            <td>
                              {/* {item.fluxo} */}
                              <input type="text" placeholder="Fluxo" value={item.fluxo} onChange={ (e) => setGenericItem(index, e.target.value, 'fluxo') } maxLength="50" disabled={view}/>
                            </td>
                            <td>
                              {/* {item.ativo} */}
                              <select value={item.ativo} onChange={ (e) => setGenericItem(index, e.target.value, 'ativo') } disabled={view}>
                                <option>Selecione</option>
                                <option value="S">Sim</option>
                                <option value="N">Não</option>
                              </select>
                            </td>
                            <td data-label="Opções">
                              <Link className="action" onClick={ (e) => rmItem(index) } >
                                <FaTrash color="#001675" size={17} />
                              </Link>
                            </td> 
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            {!view && <div className="formDiv">
              {getPermission('CONFIGURACOES - TABELAS GENERICAS - CADASTRO') && <button type="submit" className="buttonSubmit" onClick={save} disabled={view}>Salvar</button>}
              <button type="button" className="buttonCancel" onClick={cancel} disabled={view}>Cancelar</button>
            </div>}
          </form>
        </div>
      </div>}
    </div>
  )
}